export const TOOLTIP_EXIT_TIMEOUT = 350;
